import React, { useContext } from 'react';
import AppContext from '../../contexts/AppContext';
import './Tips.css';
export default function Tips() {
  const { dictionnary } = useContext(AppContext);

  return (
    <div>
      <div className="container-click-text">
        <div className="click-text">{dictionnary.get('tips-artworks')}</div>
      </div>
      <div className="container-drag-text">
        <div className="drag-text">{dictionnary.get('tips-inspiration')}</div>
      </div>
    </div>
  );
}
